import { ALDropdown } from './ALDropdown';
import { connect } from 'react-redux';
import {
  listsSel,
  listsErrorSel,
  listsIsPendingSel,
  listsActions
} from 'src/store/modules/lists';
import ListModel from 'src/model/list.model';
import ProductModel from 'src/model/product.model';
import { withI18n } from 'react-i18next';

const mapStateToProps = (state: any) => {
  return {
    lists: listsSel(state),
    error: listsErrorSel(state).message,
    isLoading: listsIsPendingSel(state)
  };
};

const mapDispatchToProps = (dispatch: any): IDispatchFromProps => ({
  onSelect: (
    list: ListModel,
    part: ProductModel,
    callback: (err?: any) => void
  ) =>
    dispatch(
      listsActions.createItem(
        list.listNumber,
        part.name || part.productNumber,
        part.manufacturerCode,
        1,
        undefined,
        undefined,
        undefined,
        callback
      )
    ),
  onCreate: (name: string, callback: (err: any, newList: ListModel) => void) =>
    dispatch(listsActions.createList(name, callback)),
  clearError: () => dispatch(listsActions.setError())
});

export const pureComponent = ALDropdown;
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withI18n()(ALDropdown));

interface IDispatchFromProps {
  onSelect: (
    list: ListModel,
    part: ProductModel,
    callback: (err?: any) => void
  ) => void;
  onCreate: (
    name: string,
    callback: (err: any, newList: ListModel) => void
  ) => void;
  clearError: () => void;
}
